import React, { useState, useEffect } from 'react';
import { getSalonInfos, updateSalonInfos, getOpeningHours, updateOpeningHours } from '../services/pocketbase';
import { FiSave, FiMapPin, FiPhone, FiFacebook, FiInstagram, FiClock, FiToggleLeft, FiToggleRight, FiGlobe } from 'react-icons/fi';
import './AdminContact.css'; // Correct path

function AdminContact() {
    const [infos, setInfos] = useState({
        name: 'Studio Ambre',
        address: '',
        phone: '',
        email: '',
        google_maps_url: '',
        home_service: false,
        home_service_text: '',
        social_facebook: '',
        social_instagram: '',
        social_tiktok: '',
        info_message: '',
        booking_enabled: true
    });
    const [infosID, setInfosID] = useState(null); // ID de l'enregistrement unique

    const [openingHours, setOpeningHours] = useState([]); // Array
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        loadAllData();
    }, []);

    const loadAllData = async () => {
        setLoading(true);
        try {
            const [infosData, hoursData] = await Promise.all([
                getSalonInfos(),
                getOpeningHours()
            ]);

            if (infosData) {
                setInfosID(infosData.id);
                setInfos({
                    name: infosData.name || '',
                    address: infosData.address || '',
                    phone: infosData.phone || '',
                    email: infosData.email || '',
                    google_maps_url: infosData.google_maps_url || '',
                    home_service: infosData.home_service || false,
                    home_service_text: infosData.home_service_text || '',
                    social_facebook: infosData.social_facebook || '',
                    social_instagram: infosData.social_instagram || '',
                    social_tiktok: infosData.social_tiktok || '',
                    info_message: infosData.info_message || '',
                    booking_enabled: infosData.booking_enabled !== undefined ? infosData.booking_enabled : true
                });
            }

            if (hoursData && hoursData.length > 0) {
                // Ensure sorting by day index (Monday=1, Sunday=7)
                setOpeningHours(hoursData.sort((a, b) => a.day - b.day));
            } else {
                // Should define a default structure if empty, but we rely on DB being seeded
                // If totally empty, maybe show a button to seed?
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleInfoSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        try {
            await updateSalonInfos(infosID, infos);
            // Also update hours (si besoin, mais ici on ne les modifie plus via la grille)
            // Mais comme on ne les affiche plus, handleHourChange n'est plus appelé
            // Donc openingHours reste tel quel.
            // On peut remove updateOpeningHours d'ici si on veut être puriste.
            // Mais le laisser ne fait pas de mal (ré-écrit l'existant).

            alert("Informations mises à jour avec succès !");
            loadAllData(); // Refresh IDs if created
        } catch (error) {
            alert("Erreur lors de la sauvegarde");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="loader">Chargement...</div>;

    return (
        <div className="admin-contact">
            <h2 className="section-title">📞 Infos & Contact</h2>

            <form onSubmit={handleInfoSubmit} className="contact-form-container">

                {/* SETTINGS GLOBAUX */}
                <div className="admin-card">
                    <h3>⚙️ Paramètres Généraux</h3>
                    <div className="form-group toggle-row">
                        <label>État de la prise de RDV en ligne</label>
                        <button
                            type="button"
                            className={`toggle-btn ${infos.booking_enabled ? 'on' : 'off'}`}
                            onClick={() => setInfos({ ...infos, booking_enabled: !infos.booking_enabled })}
                        >
                            {infos.booking_enabled ? <FiToggleRight size={24} /> : <FiToggleLeft size={24} />}
                            <span>{infos.booking_enabled ? 'ACTIVÉ' : 'DÉSACTIVÉ'}</span>
                        </button>
                        <p className="help-text">Si désactivé, le bouton "Prendre RDV" sera masqué/désactivé sur le site.</p>
                    </div>
                </div>

                {/* INFO MESSAGE CARD */}
                <div className="admin-card">
                    <h3><FiClock /> Messages & Infos Diverses</h3>
                    <div className="form-group">
                        <label>Message informatif (ex: vacances, info congés...)</label>
                        <textarea
                            value={infos.info_message}
                            onChange={e => setInfos({ ...infos, info_message: e.target.value })}
                            placeholder="Les horaires peuvent varier les jours fériés..."
                            rows="3"
                        />
                        <p className="help-text">Ce message s'affichera sous les horaires sur la page Contact.</p>
                    </div>
                </div>

                <div className="columns-2">
                    {/* COLONNE GAUCHE : COORDONNEES */}
                    <div className="admin-card">
                        <h3><FiMapPin /> Coordonnées Salon</h3>
                        <div className="form-group">
                            <label>Nom du Salon</label>
                            <input type="text" value={infos.name} onChange={e => setInfos({ ...infos, name: e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label>Adresse Complète</label>
                            <textarea value={infos.address} onChange={e => setInfos({ ...infos, address: e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label>Téléphone</label>
                            <input type="text" value={infos.phone} onChange={e => setInfos({ ...infos, phone: e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label>Lien Google Maps</label>
                            <input type="text" value={infos.google_maps_url} onChange={e => setInfos({ ...infos, google_maps_url: e.target.value })} placeholder="https://maps.google.com/..." />
                        </div>
                        <div className="form-group">
                            <label>Email (Contact)</label>
                            <input type="email" value={infos.email} onChange={e => setInfos({ ...infos, email: e.target.value })} />
                        </div>
                    </div>

                    {/* COLONNE DROITE : RESEAUX & DOMICILE */}
                    <div className="admin-card">
                        <h3><FiGlobe /> Réseaux & Services</h3>

                        <div className="form-group">
                            <label><FiFacebook /> Facebook</label>
                            <input type="text" value={infos.social_facebook} onChange={e => setInfos({ ...infos, social_facebook: e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label><FiInstagram /> Instagram</label>
                            <input type="text" value={infos.social_instagram} onChange={e => setInfos({ ...infos, social_instagram: e.target.value })} />
                        </div>
                        <div className="form-group">
                            <label>TikTok</label>
                            <input type="text" value={infos.social_tiktok} onChange={e => setInfos({ ...infos, social_tiktok: e.target.value })} />
                        </div>

                        <hr />

                        <div className="form-group checkbox-group">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={infos.home_service}
                                    onChange={e => setInfos({ ...infos, home_service: e.target.checked })}
                                />
                                Propose Coiffure à Domicile ?
                            </label>
                        </div>
                        {infos.home_service && (
                            <div className="form-group">
                                <label>Info Domicile (ex: Rayon 15km...)</label>
                                <input type="text" value={infos.home_service_text} onChange={e => setInfos({ ...infos, home_service_text: e.target.value })} />
                            </div>
                        )}
                    </div>
                </div>

                <div className="sticky-actions">
                    <button type="submit" className="btn-save-all" disabled={saving}>
                        {saving ? 'Sauvegarde...' : <><FiSave /> Enregistrer Tout</>}
                    </button>
                </div>

            </form>
        </div>
    );
}

export default AdminContact;
